import { render, staticRenderFns } from "./DividerComponent.vue?vue&type=template&id=ac2ba3fa&scoped=true"
import script from "./DividerComponent.vue?vue&type=script&lang=js"
export * from "./DividerComponent.vue?vue&type=script&lang=js"
import style0 from "./DividerComponent.vue?vue&type=style&index=0&id=ac2ba3fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac2ba3fa",
  null
  
)

export default component.exports